import * as React from 'react';
import styled from 'styled-components';
import { DeleteButton } from './DeleteButton';

interface ITextArea {
  placeholder: string;
  value: string;
  onChange?: (e: any) => void;
  onDelete?: () => void;
}

export const Textarea: React.FC<ITextArea> = ({
  placeholder,
  value,
  onChange,
  onDelete
}) => {
  return (
    <StyledInputWrapper>
      <StyledTextArea
        placeholder={placeholder}
        value={value}
        onChange={onChange ? onChange : () => null}
        hasValue={value ? value : ''}
      />
    </StyledInputWrapper>
  );
};

const StyledInputWrapper: any = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 1px solid #2c2d2d;

  &:hover {
    cursor: pointer;
    .arrow {
      border-color: white transparent transparent;
    }
  }
`;

const StyledTextArea: any = styled.textarea`
  background: transparent;
  border: none;
  width: 100%;
  padding: 20px;
  font-size: 16px;
  font-weight: 400;
  color: ${(props: any) => (props.hasValue ? 'white' : '#6f7373')};
  outline: none;

  &::-webkit-input-placeholder {
    color: #6f7373;
  }
`;
